import React from "react";
import "./Homepage.css";


export default function Homepage() {
  return (
    <div className="Homepage" id="home">
      <nav class="navbar navbar-expand-lg bg-body-white navbar-dark fixed-top">
        <div class="container-fluid">
          <a class="navbar-brand" href="#home">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                class="bi bi-house"
                viewBox="0 0 16 16"
              >
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
              </svg>
         
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav w-100">
              <li class="nav-item ms-lg-auto">
                <a class="nav-link active" aria-current="page" href="#about">
                  about
                </a>
              </li>
              <li class="nav-item">
              <a class="nav-link" href="#contact">
                  contact
                </a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" href="#work">
                  work
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href=".">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-moon"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <h1>Mia Sims</h1>
      <h3>Frontend Developer </h3>
      <p className="bio">
        I like to create front-end products with seamless designs to give users
        a cultivating experience.
      </p>
      <hr />
    </div>
  );
}
